/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The earliest pipeline stage at which a variable's inputs are available.
 */
export type ResolutionStage =
  (typeof ResolutionStage)[keyof typeof ResolutionStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolutionStage = {
  config: 'config',
  send: 'send',
  call: 'call',
} as const;
